import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '@/components/layout/Layout.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: Layout,
    children: [
      {
        path: '',
        name: 'Home',
        component: () => import('@/views/home/Home.vue'),
        meta: { title: '首页' }
      },
      {
        path: 'home',
        name: 'HomeHome',
        component: () => import('@/views/home/Home.vue'),
        meta: { title: '首页' }
      },
      {
        path: 'workflow',
        name: 'workflow',
        component: () => import('@/views/workflow/workflow.vue'),
        meta: { title: '视频复刻' }
      },
      {
        path: 'agent',
        name: 'agent',
        component: () => import('@/views/agent/agent.vue'),
        meta: { title: '智能体' }
      },
      {
        path: 'contact',
        name: 'Contact',
        component: () => import('@/views/contact/Contact.vue'),
        meta: { title: '联系我们' }
      },
      {
        path: 'bulletScreenpromotion',
        name: 'bulletScreenpromotion',
        component: () => import('@/views/promotion/bulletScreenpromotion.vue'),
        meta: { title: '弹幕推广' }
      },
      {
        path: 'aiEnterpriseMarketing',
        name: 'aiEnterpriseMarketing',
        component: () => import('@/views/promotion/AIenterpriseMarketing.vue'),
        meta: { title: 'AI企业营销' }
      },
      {
        path: 'orderSearch',
        name: 'orderSearch',
        component: () => import('@/views/promotion/orderSearch.vue'),
        meta: { title: '订单查询' }
      },
      {
        path: 'email/emailPushing',
        name: 'emailPushing',
        component: () => import('@/views/email/emailPushing.vue'),
        meta: { title: '邮件推送' }
      },
      {
        path: 'email/createOrder',
        name: 'createOrder',
        component: () => import('@/views/email/createOrder.vue'),
        meta: { title: '创建订单' }
      },
      {
        path: 'homepage',
        name: 'homepage',
        component: () => import('@/views/homepage/homepage.vue'),
        meta: { title: '我的主页' }
      },
      {
        path: 'hot-videos',
        name: 'hotVideos',
        component: () => import('@/views/hotVideos/HotVideos.vue'),
        meta: { title: '热门视频' }
      },
      {
        path: 'user/home',
        name: 'UserHome',
        component: () => import('@/views/homepage/homepage.vue'),
        meta: { title: '我的主页', requiresAuth: true }
      },
      {
        path: 'message',
        name: 'message',
        component: () => import('@/views/message/message.vue'),
        meta: { title: '个人信息' }
      },
      {
        path: 'avatarflow',
        name: 'avatarflow',
        component: () => import('@/views/avatarflow/avatarflow.vue'),
        meta: { title: 'AvatarFlow数据' }
      },
      {
        path: 'textflow',
        name: 'textflow',
        component: () => import('@/views/avatarflow/textflow.vue'),
        meta: { title: '文案复刻数据' }
      },
      {
        path: 'addWorkflow',
        name: 'addWorkflow',
        component: () => import('@/views/avatarflow/addWorkflow.vue'),
        meta: { title: '添加数字人任务' }
      },
      {
        path: 'addTextflow',
        name: 'addTextflow',
        component: () => import('@/views/avatarflow/addTextflow.vue'),
        meta: { title: '添加文案复刻任务' }
      },
      {
        path: 'simple-test',
        name: 'SimpleTest',
        component: () => import('@/components/SimpleTest.vue'),
        meta: { title: '简单测试' }
      },
      {
        path: 'workfly',
        name: 'workfly',
        component: () => import('@/views/workfly/workfly.vue'),
        meta: { title: '高级工作流副本' }
      },
      {
        path: 'videoToVideo',
        name: 'videoToVideo',
        component: () => import('@/views/agentTools/videoToVideo.vue'),
        meta: { title: '高级工作流副本' }
      },
      {
        path: 'imageToVideo',
        name: 'imageToVideo',
        component: () => import('@/views/agentTools/imageToVideo.vue'),
        meta: { title: '高级工作流副本' }
      },
      {
        path: 'vocalSeparation',
        name: 'vocalSeparation',
        component: () => import('@/views/agentTools/vocalSeparation.vue'),
        meta: { title: '人声分离' }
      },
      {
        path: 'videoWithCover',
        name: 'videoWithCover',
        component: () => import('@/views/agentTools/videoWithCover.vue'),
        meta: { title: '视频加封面' }
      },
      {
        path: 'videoTailAdd',
        name: 'videoTailAdd',
        component: () => import('@/views/agentTools/videoTailAdd.vue'),
        meta: { title: '视频加片尾' }
      },
      {
        path: 'videoAddSubtitles',
        name: 'videoAddSubtitles',
        component: () => import('@/views/agentTools/videoAddSubtitles.vue'),
        meta: { title: '视频加字幕' }
      },
      {
        path: 'videoRemoveSubtitles',
        name: 'videoRemoveSubtitles',
        component: () => import('@/views/agentTools/videoRemoveSubtitles.vue'),
        meta: { title: '视频去字幕' }
      },
      {
        path: 'videoAddMusic',
        name: 'videoAddMusic',
        component: () => import('@/views/agentTools/videoAddMusic.vue'),
        meta: { title: '视频加音乐' }
      },
      {
        path: 'textCopy',
        name: 'textCopy',
        component: () => import('@/views/agentTools/textCopy.vue'),
        meta: { title: '文案提取' }
      },
      {
        path: 'soundCloning',
        name: 'soundCloning',
        component: () => import('@/views/agentTools/soundCloning.vue'),
        meta: { title: '声音克隆' }
      },
      {
        path: 'watermarkRemove',
        name: 'watermarkRemove',
        component: () => import('@/views/agentTools/watermarkRemove.vue'),
        meta: { title: '图片去水印' }
      },
      {
        path: 'DouyinConversion',
        name: 'DouyinConversion',
        component: () => import('@/views/agentTools/DouyinConversion.vue'),
        meta: { title: '抖音链接转换' }
      },
      {
        path: 'DouyinAnalysis',
        name: 'DouyinAnalysis',
        component: () => import('@/views/agentTools/DouyinAnalysis.vue'),
        meta: { title: '抖音视频解析' }
      },
      {
        path: 'DouyinHotSpot',
        name: 'DouyinHotSpot',
        component: () => import('@/views/agentTools/DouyinHotSpot.vue'),
        meta: { title: '抖音热榜视频' }
      },
      {
        path: 'DouyinSearch',
        name: 'DouyinSearch',
        component: () => import('@/views/agentTools/DouyinSearch.vue'),
        meta: { title: '抖音视频搜索' }
      },
      {
        path: 'pictureText',
        name: 'pictureText',
        component: () => import('@/views/agentTools/pictureText.vue'),
        meta: { title: '文改图' }
      },
      {
        path: 'textToImage',
        name: 'textToImage',
        component: () => import('@/views/agentTools/textToImage.vue'),
        meta: { title: '文生图' }
      },
      {
        path: 'writingvoiceover',
        name: 'writingvoiceover',
        component: () => import('@/views/agentTools/writingvoiceover.vue'),
        meta: { title: '文案配音' }
      },
      {
        path: 'pictureUnderstanding',
        name: 'pictureUnderstanding',
        component: () => import('@/views/agentTools/pictureUnderstanding.vue'),
        meta: { title: '图片内容理解' }
      },
      {
        path: 'DouyiDownload',
        name: 'DouyiDownload',
        component: () => import('@/views/agentTools/DouyiDownload.vue'),
        meta: { title: '抖音视频下载' }
      },
      {
        path: 'resumeOrganization',
        name: 'resumeOrganization',
        component: () => import('@/views/agentTools/resumeOrganization.vue'),
        meta: { title: '简历整理' }
      },
      {
        path: 'invoiceOrganization',
        name: 'invoiceOrganization',
        component: () => import('@/views/agentTools/invoiceOrganization.vue'),
        meta: { title: '发票整理' }
      },
      {
        path: 'chinese-Japantranslation',
        name: 'chinese-Japantranslation',
        component: () => import('@/views/agentTools/chinese-Japantranslation.vue'),
        meta: { title: '汉语日语翻译' }
      },
      {
        path: 'chinese-englitranslation',
        name: 'chinese-englitranslation',
        component: () => import('@/views/agentTools/chinese-englitranslation.vue'),
        meta: { title: '汉语英语翻译' }
      },
      {
        path: 'videoFormat',
        name: 'videoFormat',
        component: () => import('@/views/agentTools/videoFormat.vue'),
        meta: { title: '视频格式转换' }
      },
      {
        path: 'audioFormat',
        name: 'audioFormat',
        component: () => import('@/views/agentTools/audioFormat.vue'),
        meta: { title: '声音格式转换' }
      },
      {
        path: 'addbackgroundMusic',
        name: 'addbackgroundMusic',
        component: () => import('@/views/agentTools/addbackgroundMusic.vue'),
        meta: { title: '视频加背景音' }
      },
      {
        path: '350APICrawler',
        name: '350APICrawler',
        component: () => import('@/views/agentTools/350APICrawler.vue'),
        meta: { title: '350API爬虫' }
      },
      {
        path: 'batchGenerationOfCopy',
        name: 'batchGenerationOfCopy',
        component: () => import('@/views/agentTools/batchGenerationOfCopy.vue'),
        meta: { title: '文案批量生成' }
      },
      {
        path: 'contractCheckAssistant',
        name: 'contractCheckAssistant',
        component: () => import('@/views/agentTools/contractCheckAssistant.vue'),
        meta: { title: '合同检查助手' }
      },
      {
        path: 'templateVoice',
        name: 'templateVoice',
        component: () => import('@/views/agentTools/templateVoice.vue'),
        meta: { title: '模板语音' }
      },
      {
        path: 'videoWithTitleWatermark',
        name: 'videoWithTitleWatermark',
        component: () => import('@/views/agentTools/videoWithTitleWatermark.vue'),
        meta: { title: '视频加标题水印' }
      }
    ]
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  if (to.name === 'Home' || to.name === 'HomeHome') {
    document.title = '数字产线首页-用AI自动生产新媒体内容'
  } else {
    document.title = to.meta.title ? `${to.meta.title} - 用AI自动生产新媒体内容` : '数字产线首页-用AI自动生产新媒体内容'
  }

  // 检查是否需要登录权限
  if (to.meta.requiresAuth) {
    // 检查用户是否已登录
    // 检查 token 和 userInfo
    const token = localStorage.getItem('token') || sessionStorage.getItem('token')
    const userInfo = localStorage.getItem('userInfo') || sessionStorage.getItem('userInfo')

    if (!token && !userInfo) {
      // 未登录，跳转到首页
      next('/')
      return
    }
  }

  next()
})

export default router
